module.exports = __webpack_public_path__ + "assets/img/wode.9a9ae752.png";